import React from 'react';

/**
 * React Context for at a glance tab metrics
 */
const AtAGlanceTabContext = React.createContext();

export default AtAGlanceTabContext;
